import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { SEMANTIC_HR_RBAC_CROSS_LINK } from '../../../../content/enterpriseMessaging';

export default function SecurityScope() {
  const copy = SEMANTIC_HR_RBAC_CROSS_LINK;

  return (
    <section className="py-16 md:py-20 border-t border-ink-100">
      <div className="container-x">
        <div className="rounded-2xl border border-brand-100 bg-gradient-to-br from-brand-50/80 to-white p-8 lg:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 lg:gap-12 items-center">
            <div className="max-w-3xl">
              <div className="flex items-center gap-2 mb-3">
                <ShieldCheckIcon className="h-5 w-5 text-brand-600" aria-hidden="true" />
                <p className="eyebrow mb-0">{copy.eyebrow}</p>
              </div>
              <h3 className="text-xl sm:text-2xl font-semibold tracking-tight text-ink-900">
                {copy.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-ink-600">{copy.body}</p>
            </div>
            <a
              href={copy.href}
              className="btn-secondary inline-flex items-center gap-2 shrink-0 whitespace-normal sm:whitespace-nowrap"
            >
              {copy.linkLabel}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
